import React, { useContext, useEffect, useRef, useState } from 'react'
import styles from '../styles/ticket.module.css'
import StateContext from '../context/state/StateContext'
import UserContext from '../context/user/UserContext'
import Status from './Status'
import axios from 'axios'
import { toast } from 'react-toastify'
import SideContent from './SideContent'
import { LuCalendarClock } from "react-icons/lu";


const Tickets = ({ data, index }) => {

    const {  setDetail, detail, token } = useContext(StateContext);
    const { user } = useContext(UserContext)
    const [ detailModal, setDetailModal ] = useState(false)

    const statusColor = () => {
        if (data.status == "generated") {
            return 'var(--accent)'
        } else if (data.status == "in progress") {
            return '#3e61af'
        } else {
            return '#7abc49'
        }
    }

    function formatDate(date){
        return new Date(date).toLocaleString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false, // Change to `true` for AM/PM format
        })
    }
    return (
        <>
            <div key={data.id} className={styles.item} onClick={() => { setDetailModal(true); setDetail({ open: true, detail: data }) }}>
                <div className={styles.item__details}>
                    <h3 className={styles.item__title}>{data.title}</h3>
                    <ul>
                        <li><b>Task No</b>. : {data.id}</li>
                        <li>
                        Deadline : {formatDate(`${data.date}T${data.time}`)}
                        </li>
                        <li>
                        Created At : {formatDate(data.created_at)}
                        </li>
                        <li className='d-flex flex-wrap' style={{alignItems:"center"}}><b>Assigned By</b> : 
                            <div className={`${styles.user} !bg-white !border-none !p-0`}>
                                    {data.generatedBy.picture ? <img src={process.env.REACT_APP_API_URL + `uploads/${data.generatedBy.picture}`} className='img-fluid' alt="" /> : <i className={`bx bxs-user-circle ${styles.img}`}></i>}
                                <p>{data.generatedBy.username}</p>
                            </div>
                        </li>
                        <li className='d-flex flex-wrap' style={{alignItems:"center"}}><b>Assigned To</b> :
                            <div className={styles.listUser}>
                                {data.users && data.users.map((item, index) => {
                                    return <div key={index} className={styles.user}>
                                        {item.picture ? <img src={process.env.REACT_APP_API_URL + `uploads/${item.picture}`} className='img-fluid' alt="" /> : <i className={`bx bxs-user-circle ${styles.img}`}></i>}
                                        <p>{item.username}</p>
                                    </div>
                                })}
                            </div>
                        </li>
                        {data?.acknowledge.length > 0 && <li className='d-flex flex-wrap' style={{alignItems:"center"}}><b>Acknowledge To</b> :
                            <div className={styles.listUser}>
                                {data?.acknowledge && data.acknowledge.map((item, index) => {
                                    return <div key={index} className={styles.user}>
                                        {item.picture ? <img src={process.env.REACT_APP_API_URL + `uploads/${item.picture}`} className='img-fluid' alt="" /> : <i className={`bx bxs-user-circle ${styles.img}`}></i>}
                                        <p>{item.username}</p>
                                    </div>
                                })}
                            </div>
                        </li>}
                    </ul>
                    {(user.role === "admin" || data.generatedById === user.id) && data.status !== "completed" && data.request_delay === "requested" ? <div className={styles.btns}>
                        <button
                            className={styles.button}
                        >
                            <LuCalendarClock color="orange" />
                            <span style={{color: "orange"}}>Requested for Delay</span>
                        </button>
                    </div> : null}
                </div>
                <div className={styles.item__rip} style={{ background: statusColor() }}></div>
                <div className={styles.item__price} style={{ background: statusColor() }}>
                    <div className='d-flex align-items-center justify-content-center flex-column'>
                        <span className={styles.heading}>Status</span>
                        <span className={styles.price}>{data.status}</span>
                        <span className={styles.heading}>{data.status == "completed" ? formatDate(data.updated_at) : null}</span>
                    </div>
                </div>
            </div>
            <SideContent data={data} open={detailModal} close={setDetailModal} />
        </>
    )
}

export default Tickets



